require('./stylesheets/services.scss');


angular.module('pages.services', [])
	.config(config);

config.$inject = ['$stateProvider'];
function config($stateProvider) {
	$stateProvider
		.state('pages.services', {
			url: 'services/:categoryId',
			template: require('./templates/index.html'),
			controller: require('./controllers/services'),
			data: {
				iframe: true,
				breadcrumbs: "SERVICES.SERVICES_HEADER"
			},
			params: {
				subscribe: null
			},
			pageTrack: '/services'
		});
}

module.exports = 'pages.services';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/services/index.js
 ** module id = 293
 ** module chunks = 1
 **/